import React, { ReactElement } from "react";
import { createPortal } from "react-dom";

interface CanvasLoaderProps {
  size?: number;
  color?: string;
}

function CanvasLoader({
  size = 40,
  color = "#fff",
}: CanvasLoaderProps): ReactElement {
  return createPortal(
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(0,0,0,0.7)",
        zIndex: 100,
      }}>
      <Spinner size={size} color={color} />
    </div>,
    document.body
  );
}

export default CanvasLoader;

const htmlElements = [0, 1, 2, 3];

interface SpinnerProps {
  size: number;
  color: string;
}
export function Spinner({ size, color }: SpinnerProps) {
  return (
    <div className="lds-ring" style={{ width: size, height: size }}>
      {htmlElements.map((item, index) => (
        <div
          key={`${index}`}
          style={{
            width: size - 4,
            height: size - 4,
            borderColor: `${color} transparent transparent transparent`,
            borderWidth: size < 50 ? 2 : 4,
          }}
        />
      ))}
    </div>
  );
}
